import { useTranslation } from 'react-i18next';
import { List, ListItemButton } from '@mui/material';
import { useSortByFilter } from 'lib/hooks/useSrpFilters';
import { colors } from 'components/styles/variables';
import { useStyles } from './styles';

interface SortByModalDropdownProps {
  onListItemClick?: (value?: string) => void;
  isSeo?: boolean;
}

export default function SortByModal({ onListItemClick }: SortByModalDropdownProps): JSX.Element {
  const classes = useStyles();
  const { value, setValue } = useSortByFilter();
  const sortByOptions = useSortFilterOptions();

  return (
    <List className={classes.sortByModal} data-testid="sort-by-options-list">
      {sortByOptions.map((option, index) => {
        const isSelected = value === option.value;
        const formattedOption = option.label;
        return (
          <ListItemButton
            key={index}
            className={classes.listItem}
            onClick={(): void => {
              setValue(option.value);
              onListItemClick?.(option.value);
            }}
            selected={isSelected}
            classes={{ selected: classes.selected }}
            style={{ padding: '12px 24px', backgroundColor: colors.WHITE }}
          >
            {isSelected && <div className={classes.selectedIcon} />}
            {formattedOption}
          </ListItemButton>
        );
      })}
    </List>
  );
}

export interface SortFilterOption {
  value: string | undefined;
  label: string;
}

export function useSortFilterOptions(): SortFilterOption[] {
  const { t } = useTranslation();
  return [
    { value: undefined, label: t('srp.sortBy.bestMatch') },
    { value: 'price:asc', label: t('srp.sortBy.priceCheap') },
    { value: 'price:desc', label: t('srp.sortBy.priceExpensive') },
    { value: 'distance:asc', label: t('srp.sortBy.distance') },
    { value: 'year:desc', label: t('srp.sortBy.yearNewest') },
    { value: 'year:asc', label: t('srp.sortBy.yearOldest') },
    { value: 'mileage:asc', label: t('srp.sortBy.mileageLowest') },
    { value: 'mileage:desc', label: t('srp.sortBy.mileageHighest') },
    { value: 'created_at:desc', label: t('srp.sortBy.timeOnMarketShortest') },
    { value: 'created_at:asc', label: t('srp.sortBy.timeOnMarketLongest') },
  ];
}
